/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AWSParam } from './awsparam';
// May contain unused imports in some cases
// @ts-ignore
import type { EdgeClusterSpec } from './edge-cluster-spec';
// May contain unused imports in some cases
// @ts-ignore
import type { GCPParam } from './gcpparam';
// May contain unused imports in some cases
// @ts-ignore
import type { NebiusParam } from './nebius-param';
// May contain unused imports in some cases
// @ts-ignore
import type { OCIParam } from './ociparam';
// May contain unused imports in some cases
// @ts-ignore
import type { Zone } from './zone';

/**
 * Message to represent edge location.
 * @export
 * @interface EdgeLocation
 */
export interface EdgeLocation {
    /**
     * AWS specific parameters.
     * @type {AWSParam}
     * @memberof EdgeLocation
     */
    'aws'?: AWSParam;
    /**
     * The cloud provider type of the edge location.
     * @type {string}
     * @memberof EdgeLocation
     */
    'cloudProviderType'?: EdgeLocationCloudProviderTypeEnum;
    /**
     * Name used to create/tag cloud resources.
     * @type {string}
     * @memberof EdgeLocation
     */
    'cloudResourceId'?: string;
    /**
     * The mode of control plane inside edge location.
     * @type {string}
     * @memberof EdgeLocation
     */
    'controlPlaneMode'?: EdgeLocationControlPlaneModeEnum;
    /**
     * The creation timestamp.
     * @type {string}
     * @memberof EdgeLocation
     */
    'createTime'?: string;
    /**
     * Custom cloud parameters.
     * @type {object}
     * @memberof EdgeLocation
     */
    'custom'?: object;
    /**
     * The deletion timestamp.
     * @type {string}
     * @memberof EdgeLocation
     */
    'deleteTime'?: string;
    /**
     * The description of the edge location.
     * @type {string}
     * @memberof EdgeLocation
     */
    'description'?: string;
    /**
     * Optional edge cluster spec overrides.
     * @type {EdgeClusterSpec}
     * @memberof EdgeLocation
     */
    'edgeClusterSpec'?: EdgeClusterSpec;
    /**
     * If state if failed, this field will contain the error message.
     * @type {string}
     * @memberof EdgeLocation
     */
    'error'?: string;
    /**
     * Google Cloud specific parameters.
     * @type {GCPParam}
     * @memberof EdgeLocation
     */
    'gcp'?: GCPParam;
    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeLocation
     */
    'id'?: string;
    /**
     * The name of the edge location.  Name must be quote short as we are creating service accounts with this name,  and GCP has a limit of 30 characters for service account names.
     * @type {string}
     * @memberof EdgeLocation
     */
    'name': string;
    /**
     * Nebius cloud parameters.
     * @type {NebiusParam}
     * @memberof EdgeLocation
     */
    'nebius'?: NebiusParam;
    /**
     * OCI cloud parameters.
     * @type {OCIParam}
     * @memberof EdgeLocation
     */
    'oci'?: OCIParam;
    /**
     * The region of edge location.
     * @type {string}
     * @memberof EdgeLocation
     */
    'region'?: string;
    /**
     * The state of the edge location on API level.
     * @type {string}
     * @memberof EdgeLocation
     */
    'state'?: EdgeLocationStateEnum;
    /**
     * Total amount of edges in a given edge location.
     * @type {number}
     * @memberof EdgeLocation
     */
    'totalEdgeCount'?: number;
    /**
     * The last update timestamp.
     * @type {string}
     * @memberof EdgeLocation
     */
    'updateTime'?: string;
    /**
     * The zones of edge location.
     * @type {Array<Zone>}
     * @memberof EdgeLocation
     */
    'zones'?: Array<Zone>;
}

export const EdgeLocationCloudProviderTypeEnum = {
    CLOUD_PROVIDER_TYPE_UNSPECIFIED: 'CLOUD_PROVIDER_TYPE_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    OCI: 'OCI',
    NEBIUS: 'NEBIUS',
    CUSTOM: 'CUSTOM'
} as const;

export type EdgeLocationCloudProviderTypeEnum = typeof EdgeLocationCloudProviderTypeEnum[keyof typeof EdgeLocationCloudProviderTypeEnum];
export const EdgeLocationControlPlaneModeEnum = {
    CONTROL_PLANE_MODE_UNSPECIFIED: 'CONTROL_PLANE_MODE_UNSPECIFIED',
    DEDICATED: 'DEDICATED',
    SHARED: 'SHARED'
} as const;

export type EdgeLocationControlPlaneModeEnum = typeof EdgeLocationControlPlaneModeEnum[keyof typeof EdgeLocationControlPlaneModeEnum];
export const EdgeLocationStateEnum = {
    STATE_UNSPECIFIED: 'STATE_UNSPECIFIED',
    INITIALIZING: 'INITIALIZING',
    READY: 'READY',
    DELETED: 'DELETED',
    FAILED: 'FAILED',
    PENDING_ONBOARDING: 'PENDING_ONBOARDING',
    OFFBOARDING: 'OFFBOARDING'
} as const;

export type EdgeLocationStateEnum = typeof EdgeLocationStateEnum[keyof typeof EdgeLocationStateEnum];


